import React, { useState, useEffect } from "react";
import InviteButton from "../components/InviteButton";
import { fetchReferral } from "../core/api/referral";

const FrenPage = () => {
  const [referralCount, setReferralCount] = useState(0);
  const [referralTotalPoint, setReferralTotalPoint] = useState(0);
  const [referralPoint, setReferralPoint] = useState(0);
  const [referralBoots, setReferralBoots] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const [shareUrl, setShareUrl] = useState(null);
  const [targetReferralCode, setTargetReferralCode] = useState("");
  const [shareMessage, setShareMessage] = useState("");
  const tg_info = JSON.parse(localStorage.getItem("tg_info"));
  const tgUserId = tg_info?.tgUserId;
  const botName = tg_info?.botName;

  useEffect(() => {
    if (botName) {
      setShareUrl(
        `https://t.me/share/url?url=https://t.me//${botName}?start=referralapp=referral=`
      );
    }
    const getReferral = async () => {
      const currentTgUserId = tgUserId
        ? tgUserId
        : JSON.parse(localStorage.getItem("tg_info"))?.tgUserId;
      if (currentTgUserId) {
        const resp = await fetchReferral(currentTgUserId);
        if (resp) {
          setTargetReferralCode(resp.referral_code);
          setShareMessage(decodeURIComponent(resp.referral_message));
          setReferralCount(resp.referral_count);
          setReferralTotalPoint(resp.referral_total_points);
          setReferralPoint(resp.referral_invite_points);
          setReferralBoots(resp.referral_invite_bonus_boots);
        }
      }
    };
    getReferral();
  }, [botName, tgUserId]);

  const copyToClipboard = () => {
    const text = `https://t.me//${botName}?start=referralapp=referral=${targetReferralCode}&\n\n${shareMessage}`;
    try {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          alert("successfully copied");
          // setIsVisible(true);
        })
        .catch(() => {
          const textArea = document.createElement("textarea");
          textArea.textContent = text;
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
          alert("successfully copied");
          // setIsVisible(true);
        });
    } catch (e) {
      console.log(e);
      alert("copied failed");
    }
  };

  console.log("share link", shareUrl + targetReferralCode + shareMessage);
  return (
    <div className="FremsPageContainer">
      <div className="containerContent">
        <div className="invitePageImage">
          <img src="/image/InvitePage.png" alt="invitePage" width="100%" />
        </div>
        <div className="FremsContent">
          <div className="fremsPageTitle" style={{ flex: 2 }}>
            Invite friends to maximize your chance to win
          </div>
          <div className="referralRule" style={{ flex: 2 }}>
            <div className="fremText">Referral Rule</div>
            <div
              className="fremText"
              style={{ display: "flex", alignItems: "center" }}>
              <span style={{ padding: "0 4px 0 4px" }}>
                1 invite = {referralPoint.toLocaleString()} points
              </span>
              <img src="/image/coin.png" alt="invitePage" width="16px" />
            </div>
          </div>
          <div
            className="invitedUser"
            style={{
              flex: 1,
              borderBottom: "1px solid white",
              width: "90%",
              maxWidth: "358px",
            }}>
            <div
              className="fremText"
              style={{ display: "flex", alignItems: "center" }}>
              <img src="/image/invite.png" alt="invite" width="16px" />
              <span style={{ margin: "0 5px 0 5px" }}>
                Invited:{referralCount}
              </span>
            </div>
            <div className="fremText">
              {referralTotalPoint.toLocaleString()} Pts Rewarded
            </div>
          </div>
        </div>
        {isVisible && (
          <div className="alertStyle">
            <p>successfully copied!</p>
            <button onClick={() => setIsVisible(false)} className="alertButtonStyle">
              Close
            </button>
          </div>
        )}
        <div style={{ background: "#896da7" }} className="buttonContainer">
          <InviteButton
            customClassName="leftSideInviteBonus"
            shareUrl={shareUrl + targetReferralCode + "&text=" + shareMessage}
            referralBoots={referralBoots}
          />
          <div className="copyButton" onClick={copyToClipboard}>
            <img src="/image/copy.png" alt="copy" width="20px" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default FrenPage;
